export default class SiteHeader {
    constructor() {
        this.mobileMenuBtn = document.getElementById('mobile_menu_btn');
        this.mobileMenu()
        this.mobileSubmenu();
        this.search();
        this.languageSwitcher();
        window.addEventListener('resize', () => {
            this.mobileMenuBtn.classList.remove('is-open');
            document.querySelector('.site-header__nav').classList.remove('is-open');
            this.resetMobileSubmenu();
        }, true);
    }

    mobileMenu() {
        this.mobileMenuBtn.onclick = () => {
            document.getElementById('site_search_btn').classList.remove('is-open');
            document.querySelector('form.site-search').classList.remove('is-open');
            this.resetMobileSubmenu();
            this.mobileMenuBtn.classList.toggle('is-open');
            document.querySelector('.site-header__nav').classList.toggle('is-open');
        }
    }

    mobileSubmenu() {
        const submenuItems = document.querySelectorAll('.menu-item-has-children');
        if (!submenuItems) {
            return;
        }
        Array.from(submenuItems).forEach((item) => {
            item.onclick = (event) => {
                if (event.target === item) {
                    item.classList.toggle('is-open');
                }
            }
        })
    }

    resetMobileSubmenu() {
        const submenuItems = document.querySelectorAll('.menu-item-has-children.is-open');
        if (!submenuItems) {
            return;
        }
        Array.from(submenuItems).forEach((item) => {
            item.classList.remove('is-open');
        });
    }

    search() {
        const openBtn = document.getElementById('site_search_btn'),
              searchForm = document.querySelector('form.site-search'),
              closeBtn = document.querySelector('.site-search__close');
        openBtn.onclick = (event) => {
            searchForm.classList.toggle('is-open');
            openBtn.classList.toggle('is-open');
            this.mobileMenuBtn.classList.remove('is-open');
            document.querySelector('.site-header__nav').classList.remove('is-open');
            this.resetMobileSubmenu();
        }

        closeBtn.onclick = (event) => {
            searchForm.classList.toggle('is-open');
            openBtn.classList.toggle('is-open');
        }
    }

    languageSwitcher() {
        const openBtn = document.getElementById('language_switcher_btn')
        if (!openBtn) {
            return;
        }
        openBtn.onclick = (event) => {
            openBtn.classList.toggle('is-open');
        }

    }

}
  

